module.exports = __webpack_public_path__ + "bundle/assets/item-arrow-closed-white.19f91bff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/kiosk/assets/item-arrow-closed-white.svg
// module id = 66
// module chunks = 0